import $ from 'jquery';
import { RouteParams } from 'universal-router';
import { tns } from 'tiny-slider';
import { PublicPage } from '../PublicPage';

export class ViewPage extends PublicPage {
    public static render(params: RouteParams): void {
        super.render(params);

        ViewPage._initImagesBehavior();
    }

    private static _initImagesBehavior(): void {
        ViewPage._initTinySlider();
    }

    private static _initTinySlider(): void {

        document.querySelectorAll('.images-slider').forEach(slider => {
            tns({
                container: slider,
                loop: true,
                items: 1,
                navAsThumbnails: true,
                navContainer: $(slider).data('nav'),
                controls: false,
            });
        });

        document.querySelectorAll('.thumb-slider').forEach(slider => {
            tns({
                loop: true,
                container: slider,
                items: 4,
                mouseDrag: true,
                nav: false,
                controls: false,
            });
        });
    }
}
